import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
  min-height: 100vh;
`;

export const Form = styled.form`
  width: 40vw;
  background-color: ${(props) => props.theme.tokens.colors.surface};
  padding: 40px;
  margin: 40px 0;
  border-radius: ${(props) => props.theme.tokens.radii.xl}px;
  box-shadow: ${(props) => props.theme.tokens.shadows.card};

  @media (max-width: 1024px) {
    width: 70vw;
    padding: 24px;
  }
`;

export const FormTitle = styled.h2`
  font-family: ${(props) => props.theme.tokens.font.family};
  color: ${(props) => props.theme.tokens.colors.ink};
  font-weight: 900;
  font-size: 26px;

  padding-bottom: 24px;
`;

export const Section = styled.p`
  font-family: ${(props) => props.theme.tokens.font.family};
  color: ${(props) => props.theme.tokens.colors.ink};
  font-weight: 800;
  font-size: 16px;

  padding-bottom: 16px;
  padding-top: 16px;
`;

export const LoadingText = styled.h1`
  font-family: ${(props) => props.theme.tokens.font.family};
  color: ${(props) => props.theme.tokens.colors.ink};
  font-weight: 800;
  font-size: 20px;
  text-align: center;
  margin-top: 40px;
`;

export const ButtonContainer = styled.div`
  text-align: center;
  padding-top: 20px;
`;
